<ng-content></ng-content>


// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/syllabuses/syllabus-add-button/syllabus-add-button.component.ts.SyllabusAddButtonComponent.html